<ng-template #settingsTemplate>
    <app-tool-setting label="Getallenlijn">
        <app-check-box
            label="Toon getallenlijn"
            [checked]="showNumberLine"
            (checkedChange)="showNumberLine = $event"
        ></app-check-box>
    </app-tool-setting>
    @if (showNumberLine) {
    <app-tool-setting label="Getallen op getallenlijn">
        <div class="options-grid">
            <app-check-box
                label="Getallen"
                [checked]="showNumbers"
                (checkedChange)="showNumbers = $event"
            ></app-check-box>
            <app-check-box
                label="Eenheden"
                [checked]="showUnits"
                (checkedChange)="showUnits = $event"
            ></app-check-box>
        </div>
    </app-tool-setting>
    }
    <app-tool-setting label="Label">
        <app-svg-input [options]="svgList" [parent]="instance"></app-svg-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        class="slider"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 201.3 8.4"
        style="enable-background: new 0 0 201.3 8.4"
        xml:space="preserve"
        (mouseleave)="onMouseLeave()"
    >
        <style type="text/css">
            .chain20-hide-ball path {
                fill: transparent;
            }

            .stChain200 {
                fill: none;
                stroke: #000000;
                stroke-miterlimit: 10;
            }

            .stChain201 {
                fill: url(#SVGID_1_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain202 {
                fill: url(#SVGID_2_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain203 {
                fill: url(#SVGID_3_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain204 {
                fill: url(#SVGID_4_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain205 {
                fill: url(#SVGID_5_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain206 {
                fill: url(#SVGID_6_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain207 {
                fill: url(#SVGID_7_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain208 {
                fill: url(#SVGID_8_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain209 {
                fill: url(#SVGID_9_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2010 {
                fill: url(#SVGID_10_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2011 {
                fill: #e5232b;
            }

            .stChain2012 {
                opacity: 0.3;
            }

            .stChain2013 {
                fill: #ffffff;
            }

            .stChain2014 {
                fill: url(#SVGID_11_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2015 {
                fill: url(#SVGID_12_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2016 {
                fill: url(#SVGID_13_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2017 {
                fill: url(#SVGID_14_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2018 {
                fill: url(#SVGID_15_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2019 {
                fill: url(#SVGID_16_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2020 {
                fill: url(#SVGID_17_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2021 {
                fill: url(#SVGID_18_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2022 {
                fill: url(#SVGID_19_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2023 {
                fill: #dadada;
            }

            .stChain2024 {
                opacity: 0.6;
            }

            .stChain2025 {
                fill: url(#SVGID_20_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2026 {
                fill: url(#SVGID_21_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2027 {
                fill: url(#SVGID_22_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2028 {
                fill: url(#SVGID_23_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2029 {
                fill: url(#SVGID_24_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2030 {
                fill: url(#SVGID_25_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2031 {
                fill: url(#SVGID_26_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2032 {
                fill: url(#SVGID_27_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2033 {
                fill: url(#SVGID_28_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2034 {
                fill: url(#SVGID_29_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2035 {
                fill: url(#SVGID_30_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2036 {
                fill: url(#SVGID_31_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2037 {
                fill: url(#SVGID_32_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2038 {
                fill: url(#SVGID_33_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2039 {
                fill: url(#SVGID_34_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2040 {
                fill: url(#SVGID_35_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2041 {
                fill: url(#SVGID_36_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2042 {
                fill: url(#SVGID_37_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }

            .stChain2043 {
                fill: url(#SVGID_38_);
                stroke: #0090c9;
                stroke-width: 0.15;
            }
        </style>
        <path
            d="M184.1,4.9c0-0.5,0.5-0.7,0.5-1c3.3,0.5,4.4-1,8.3-0.4c5.1,0.7,8.6,2.7,8.6,2.7s-5.8-2.4-9.7-2.3
        C187.5,4,187.2,5.4,184.1,4.9z"
        />
        <path
            d="M17.1,4.9c0-0.5-0.4-0.7-0.4-1c-3.2,0.5-4.4-1-8.3-0.4c-5,0.7-8.4,2.7-8.4,2.7s5.7-2.4,9.5-2.3C13.8,4,14.1,5.3,17.1,4.9z"
        />
        <line class="stChain200" x1="16.6" y1="4.4" x2="184.7" y2="4.5" />

        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain2011"
                    d="M22.6,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S16,0,18.3,0C20.7,0,22.6,1.9,22.6,4.2z"
                />
            </g>
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M15.8,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C16.8,0.9,16.1,1.4,15.8,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M22.6,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C24.5,8.4,22.6,6.5,22.6,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M24.4,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3C26.6,2,28,1.5,27.6,1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C25.4,1,24.7,1.5,24.4,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M31.1,4.2C31.1,1.9,33,0,35.4,0c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C33,8.4,31.1,6.5,31.1,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M33,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C34,1.2,33.4,1.6,33,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M39.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C41.5,8.4,39.7,6.5,39.7,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M41.4,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C42.4,1.2,41.8,1.6,41.4,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M48.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C50.1,8.4,48.2,6.5,48.2,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M49.9,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C50.9,1.2,50.2,1.6,49.9,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain2023"
                    d="M65.2,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S58.6,0,60.9,0C63.3,0,65.2,1.9,65.2,4.2z"
                />
            </g>
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M58.4,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3C60.7,1.9,62,1.4,61.7,1
                c-0.3-0.4-1.1-0.3-1.6-0.2C59.4,0.9,58.7,1.4,58.4,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M65.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C67.1,8.4,65.2,6.5,65.2,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M67,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C68,1,67.3,1.5,67,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M73.7,4.2C73.7,1.9,75.6,0,78,0c2.3,0,4.2,1.9,4.2,4.2S80.3,8.4,78,8.4C75.6,8.4,73.7,6.5,73.7,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M75.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C76.6,1.2,76,1.6,75.6,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M82.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C84.2,8.4,82.3,6.5,82.3,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M84,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                C87,0.8,86.2,0.9,85.8,1C85,1.2,84.4,1.6,84,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M90.8,4.2C90.8,1.9,92.7,0,95,0c2.3,0,4.2,1.9,4.2,4.2S97.3,8.4,95,8.4C92.7,8.4,90.8,6.5,90.8,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M92.5,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C93.5,1.2,92.8,1.6,92.5,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <g>
                    <path
                        class="stChain2011"
                        d="M107.7,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C105.8,0,107.7,1.9,107.7,4.2z"
                    />
                </g>
            </g>
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M100.9,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C101.9,0.9,101.2,1.4,100.9,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M107.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C109.6,8.4,107.7,6.5,107.7,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M109.5,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C110.5,1,109.8,1.5,109.5,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M116.2,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C118.1,8.4,116.2,6.5,116.2,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M118.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C119.1,1.2,118.4,1.6,118.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M124.7,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C126.6,8.4,124.7,6.5,124.7,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M126.5,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C127.5,1.2,126.9,1.6,126.5,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2011"
                d="M133.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C135.1,8.4,133.3,6.5,133.3,4.2"
            />
            <g class="stChain2012">
                <g>
                    <path
                        class="stChain2013"
                        d="M135,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C136,1.2,135.3,1.6,135,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <g>
                <path
                    class="stChain2023"
                    d="M150.3,4.2c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2S143.7,0,146,0C148.4,0,150.3,1.9,150.3,4.2z"
                />
            </g>
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M143.5,2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C144.5,0.9,143.8,1.4,143.5,2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M150.3,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C152.2,8.4,150.3,6.5,150.3,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M152.1,2.1c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C153.1,1,152.4,1.5,152.1,2.1z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M158.8,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C160.7,8.4,158.8,6.5,158.8,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M160.7,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C161.7,1.2,161,1.6,160.7,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M167.4,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C169.2,8.4,167.4,6.5,167.4,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M169.1,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C170.1,1.2,169.5,1.6,169.1,2.2z"
                    />
                </g>
            </g>
        </g>
        <g
            class="ball"
            (mousedown)="onBallMouseDown()"
            (mouseover)="onBallMouseOver($event)"
            (mouseup)="onBallMouseUp()"
            (click)="onBallClick($event)"
        >
            <path
                class="stChain2023"
                d="M175.9,4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2C177.8,8.4,175.9,6.5,175.9,4.2"
            />
            <g class="stChain2024">
                <g>
                    <path
                        class="stChain2013"
                        d="M177.6,2.2c-0.2,0.4-0.4,1-0.2,1.4c0.2,0.3,0.4,0.2,0.6,0c0.5-0.5,1-1,1.6-1.3c0.2-0.1,1.6-0.7,1.2-1.1
                c-0.3-0.4-1.1-0.3-1.6-0.2C178.6,1.2,177.9,1.6,177.6,2.2z"
                    />
                </g>
            </g>
        </g>
    </svg>
    @if (showNumberLine) {
    <svg
        class="number-line"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 461.497 26.059"
        style="enable-background: new 0 0 461.497 26.059"
        xml:space="preserve"
    >
        <path
            style="fill: none; stroke: #000000; stroke-width: 0.5"
            d="M0,7.087h461.497"
        />
        @if (showNumbers) {
        <g class="chain20-numbers">
            <g style="enable-background: new">
                <path
                    d="M5.692,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
            C6.194,24.146,5.692,22.786,5.692,21.053z M9.203,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
            c0,1.428,0.323,2.541,1.453,2.541S9.203,22.48,9.203,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M226.901,23.517h1.334v-4.386c0-0.17,0.008-0.332,0.008-0.332h-0.017c0,0-0.059,0.127-0.297,0.357l-0.637,0.638
            l-0.374-0.382l1.351-1.343h0.561v5.448h1.309v0.527h-3.238V23.517z"
                />
                <path
                    d="M230.777,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
            C231.279,24.146,230.777,22.786,230.777,21.053z M234.288,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
            c0,1.428,0.323,2.541,1.453,2.541S234.288,22.48,234.288,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M452.583,19.65c0-0.638-0.468-1.122-1.224-1.122c-0.595,0-1.062,0.306-1.062,0.646v0.281h-0.561v-0.442
            c0-0.756,1.028-1.045,1.64-1.045c1.139,0,1.819,0.748,1.819,1.674c0,2.099-3.162,2.048-3.162,3.706c0,0.119,0.068,0.17,0.195,0.17
            h2.499c0.119,0,0.188-0.06,0.188-0.187v-0.399h0.552v0.595c0,0.366-0.152,0.519-0.519,0.519h-2.991
            c-0.408,0-0.535-0.17-0.535-0.586C449.422,21.24,452.583,21.418,452.583,19.65z"
                />
                <path
                    d="M454.318,21.053c0-1.717,0.502-3.085,2.058-3.085c1.555,0,2.065,1.368,2.065,3.085c0,1.734-0.511,3.094-2.065,3.094
            C454.82,24.146,454.318,22.786,454.318,21.053z M457.829,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.454,1.113-1.454,2.533
            c0,1.428,0.323,2.541,1.454,2.541C457.505,23.594,457.829,22.48,457.829,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M117.727,22.88c0,0,0.45,0.706,1.385,0.706c0.85,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
            c-0.671,0-1.147,0.332-1.147,0.332l-0.306-0.127l0.255-2.405c0.034-0.365,0.153-0.519,0.519-0.519h1.963
            c0.357,0,0.51,0.153,0.51,0.519v0.595h-0.553v-0.399c0-0.128-0.068-0.187-0.187-0.187h-1.513c-0.119,0-0.17,0.059-0.187,0.187
            l-0.153,1.351c-0.025,0.212-0.051,0.34-0.051,0.34h0.017c0,0,0.374-0.221,0.901-0.221c1.216,0,2.091,0.867,2.091,1.946
            c0,1.062-0.884,1.946-2.099,1.946c-1.19,0-1.759-0.85-1.759-0.85L117.727,22.88z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M338.57,23.517h1.334v-4.386c0-0.17,0.009-0.332,0.009-0.332h-0.017c0,0-0.06,0.127-0.298,0.357l-0.638,0.638l-0.374-0.382
            l1.352-1.343h0.562v5.448h1.309v0.527h-3.238V23.517z"
                />
                <path
                    d="M342.845,22.88c0,0,0.45,0.706,1.386,0.706c0.85,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
            c-0.672,0-1.147,0.332-1.147,0.332l-0.307-0.127l0.255-2.405c0.034-0.365,0.153-0.519,0.519-0.519h1.964
            c0.356,0,0.51,0.153,0.51,0.519v0.595h-0.553v-0.399c0-0.128-0.067-0.187-0.187-0.187h-1.513c-0.119,0-0.17,0.059-0.188,0.187
            l-0.152,1.351c-0.026,0.212-0.052,0.34-0.052,0.34h0.018c0,0,0.374-0.221,0.9-0.221c1.216,0,2.091,0.867,2.091,1.946
            c0,1.062-0.884,1.946-2.099,1.946c-1.19,0-1.76-0.85-1.76-0.85L342.845,22.88z"
                />
            </g>
        </g>
        }
        <g class="chain20-big-ticks">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M7.75,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M119.312,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M230.875,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M342.437,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M453.997,0v14.173"
            />
        </g>
        @if (showUnits) {
        <g class="chain20-small-ticks">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M30.062,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M52.375,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M74.687,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M97,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M141.625,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M163.937,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M186.25,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M208.562,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M253.187,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M275.5,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M297.812,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M320.125,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M364.75,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M387.06,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M409.372,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M431.684,4.252v5.669"
            />
        </g>
        }
    </svg>
    }
</ng-template>
